import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { RootState } from './types';
import { user } from './user/index';
import { devices } from './devices/index';
import { views } from './views/index';
import { relays } from './relays/index';
import { buttonsView } from './views/buttonsView';
import { relaysView } from './views/relaysView';
import { floorplanView } from './views/floorplanView';
import { tilesView } from './views/tilesView';
import VuexPersistence from 'vuex-persist';
import { n2k } from './n2k';
import { logging } from './logging';
import ApiProvider from '@/common/apis/ApiProvider';

Vue.config.devtools = true;

// window.localStorage.clear();
const vuexLocal = new VuexPersistence<RootState>({
  storage: window.localStorage,
  modules: ['user'],

});

Vue.use(Vuex);
const store: StoreOptions<RootState> = {
  state: {
      version: '1.0.0',
  },
  modules: {
    user,
    devices,
    views,
    relays,
    buttonsView,
    relaysView,
    floorplanView,
    tilesView,
    n2k,
    logging,
  },
  plugins: [vuexLocal.plugin],
  actions: {
      async logOff() {
        await this.dispatch('clear');
        await this.dispatch('user/logOff');
        ApiProvider.clearBearerToken();
      },
      async clear() {
        await this.commit('n2k/clear');
        await this.commit('logging/clear');
        await this.commit('devices/clear');
        await this.commit('relays/clear');
        await this.commit('relays/clear');
        await this.commit('views/clear');
      },
  },
};
export default new Vuex.Store<RootState>(store);
